var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-input__wrapper"},[_vm._t("default"),(_vm.max)?_c('span',{staticClass:"v-input__counter",class:{ 'v-input__counter--error': _vm.length >= _vm.max }},[_vm._v(_vm._s(_vm.length ?? 0)+"/"+_vm._s(_vm.max)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }